import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

type NationalityData = {
  Name: string;
  Value: number;
};

export const NationalitiesDemoGraphicView = ({ data }: { data?: NationalityData[] }) => {
  const barColors = [
    "#E55050",
    "#008048",
    "#35B1E8",
    "#FFA51F",
    "#FEBEC8",
    "#4C5167",
    "#008044",
    "#35B1E8",
  ];

  const categories = data?.map((item) => item.Name) || [];

  const chartData =
    data?.map((item, index) => ({
      y: item.Value,
      color: barColors[index % barColors.length],
    })) || [];

  const options: Highcharts.Options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Nationalities Distribution",
    },
    xAxis: {
      categories, // ✅ show names as x labels
      labels: {
        style: {
          fontSize: "10px",
          color: "black",
        },
        rotation: -45, // ✅ rotate so long names don't overlap
      },
      title: { text: "Nationalities" },
    },
    yAxis: {
      title: { text: "Value", style: { fontSize: "11px", color: "black" } },
      labels: { style: { fontSize: "11px", color: "black" } },
    },
    tooltip: {
      pointFormat: "<b>{point.y}</b>",
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      column: {
        borderRadius: 5,
        dataLabels: {
          enabled: true,
          format: "{point.y}",
        },
      },
    },
    series: [
      {
        name: "Value",
        type: "column",
        data: chartData,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
